<div class="d-flex">
  <div class="header bg-primary-dark flex-fill" [class.bg-light]='theme === "light"'>
    <ng-content></ng-content>
  </div>
</div>